export default ({ app, route }) => {
  const siteUrl = process.env.VUE_APP_URL;
  const lang = process.env.VUE_APP_LANG;
  const region = process.env.VUE_APP_REGION;
  const altSites = process.env.VUE_APP_ALT_SITES
    ? JSON.parse(process.env.VUE_APP_ALT_SITES)
    : [];

  const currentPath = route.path;
  const currentUrl = `${siteUrl}${currentPath}`;

  if (!altSites.length) return;

  const hreflangs = [
    { rel: 'canonical', href: currentUrl },
    { rel: 'alternate', hreflang: `${lang}-${region}`, href: currentUrl },
    { rel: 'alternate', hreflang: 'x-default', href: siteUrl },
  ];

  for (const alt of altSites) {
    hreflangs.push({
      rel: 'alternate',
      hreflang: alt.code,
      href: `${alt.url}${currentPath}`,
    });
  }

  app.head = app.head || {};
  app.head.link = [...(app.head.link || []), ...hreflangs];
};
